module.exports = __webpack_public_path__ + "img/final.9da639c9.png";